<app-admin-navbar></app-admin-navbar>
<div class="page">

  <h1>Products</h1>

<button class="btn-add" routerLink="/admin/products/new">Dodaj proizvod</button>
 <div
  class="spinner-container"

  *ngIf="loading">

  <div class="spinner">
  </div>

  <p>
    Učitavanje proizvoda u toku...
  </p>

</div>

  <table *ngIf="!loading">
    <thead>
      <tr>
        <th>ID</th>
        <th>Name</th>
        <th>Slug</th>
        <th>Description</th>
        <th>Main Image</th>
        <th>Featured</th>
        <th>Category ID</th>
        <th>Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of products">
        <td>{{ product.id }}</td>
        <td>{{ product.name }}</td>
        <td>{{ product.slug }}</td>
        <td>{{ product.description }}</td>
        <td>
          <img *ngIf="product.mainImage" [src]="product.mainImage" alt="{{ product.name }}" width="60" />
          <span *ngIf="!product.mainImage">—</span>
        </td>
        <td>{{ product.featured ? 'Yes' : 'No' }}</td>
       <td>{{ product.category?.name }}</td>
        <td class="actions">
  <button
    class="btn-edit"
    [routerLink]="['/admin/products/edit', product.id]">

    Edit

  </button>

  <button
    class="btn-showcase"
    [routerLink]="['/admin/products/details', product.id]">

    Detalji

  </button>

  <button
    class="btn-delete"
    (click)="deleteProduct(product.id)">

    Delete

  </button>

        </td>
      </tr>
    </tbody>
  </table>

</div>